import request from '@/utils/request'

// 获取团队路线
export function GetTeamRouteList (params) {
  return request({
    url: 'post/route/GetTeamRouteList',
    data: params
  })
}
// 多车路线规划
export function MultiVehicleRoutePlanner (params) {
  return request({
    url: 'post/route/MultiVehicleRoutePlanner',
    data: params
  })
}

// 路线规划
export function RoutePlanning (params) {
  return request({
    url: 'post/route/RoutePlanning',
    data: params
  })
}

// 路线规划 [京遇]
export function JYRoutePlanner (params) {
  return request({
    url: 'post/jy/RoutePlanner',
    data: params
  })
}

export function SetRouteUser (params) {
  return request({
    url: 'post/route/SetRouteUser',
    data: params
  })
}

export function SaveRouteRemarks (params) {
  return request({
    url: 'post/route/SaveRouteRemarks',
    data: params
  })
}

export function GetRouteDetails (params) {
  return request({
    url: 'post/route/GetRouteDetails',
    data: params
  })
}


export function GetRoutePlace (params) {
  return request({
    url: 'post/route/GetRoutePlace',
    data: params
  })
}

export function GetRouteMapDetails (params) {
  return request({
    url: 'post/route/GetRouteMapDetails',
    data: params
  })
}

export function DeleteRoute (params) {
  return request({
    url: 'post/route/DeleteRoute',
    data: params
  })
}

export function BatchDeleteRoute (params) {
  return request({
    url: 'post/route/BatchDeleteRoute',
    data: params
  })
}

export function ExportRoute (params) {
  return request({
    url: 'post/route/ExportRoute',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/route.js